<template>
  <div v-show="editShow">
    <div class="container">
      <el-row :gutter="20">
        <div class="clearfix">
          <div class="crumbs">
            <i class="el-icon-back"></i>
            <el-button type="text" @click="goBack">返回</el-button>
          </div>
          <div class="btn-save">
            <el-button type="primary" @click="saveClick('ruleForm')"
            >保存
            </el-button
            >
          </div>
        </div>
        <div class="form-box">
          <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="130px"
              class="eidt-el-form"
          >
            <el-form-item label="会议名称" prop="name">
              <el-input v-model="ruleForm.name"
                        placeholder="会议名称"></el-input>
            </el-form-item>
            <el-form-item label="会议编号" prop="code">
              <el-input
                  v-model="ruleForm.code"
                  placeholder="会议编号"
              ></el-input>
            </el-form-item>
            <el-form-item label="场馆" prop="hallhall">
              <el-input
                  v-model="ruleForm.hall"
                  placeholder="场馆"
              ></el-input>
            </el-form-item>
            <el-form-item label="是否启用" prop="enable">
              <el-switch v-model="ruleForm.enable"></el-switch>
            </el-form-item>
            <el-form-item label="开始时间" prop="startDate">
              <el-date-picker
                  v-model="ruleForm.startDate"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="开始日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间" prop="endDate">
              <el-date-picker
                  v-model="ruleForm.endDate"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="证件图片" prop="width">
              <el-input
                  v-model="ruleForm.logo"
              ></el-input>
            </el-form-item>
            <UploadImg
                @uploadImg="getUploadImg"
                :editImg="editImg"
                :imgTitle="imgTitle"
            ></UploadImg>
          </el-form>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import UploadImg from "../../public/UploadImg";

export default {
  name: "edittypemanage",
  data() {
    return {
      rules: {
        name: [
          {required: true, message: "请填写会议名称", trigger: "blur"},
        ],
        code: [
          {required: true, message: "请填写会议编号", trigger: "blur"},
        ],
        enable: [
          {required: true, message: "请填写会议是否启用", trigger: "blur"},
        ],
        endDate: [
          {required: true, message: "结束日期不能为空", trigger: "blur"},
        ],
        startDate: [
          {required: true, message: "开始日期不能为空", trigger: "blur"},
        ],
      },
      ruleForm: {
        enable: false,
        name: "",
        hall: "",
        code: "",
        logo: "",
        startDate: "",
        endDate: "",
        projectId: localStorage.getItem("project_Id"),
      },
      editImg: "",
      meetingId: "",
      dataList: [],
      imgTitle: "上传logo",
    };
  },
  props: {
    editShow: {
      type: Boolean,
      default: false,
    },
    arrarList: {
      type: Array,
      default() {
        return [];
      },
    },
    editData: {
      type: Object,
    },
  },
  watch: {
    editData: function () {
      const item = this.editData;
      this.ruleForm = item ? item : this.ruleForm;
      this.meetingId = item.meetingId;
      this.editImg = item.logo;
    },
  },
  methods: {
    saveClick(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          if (this.meetingId == "" || this.meetingId == undefined) {
            this.$axios.post("/Meeting/", this.ruleForm).then((res) => {
              if (res.data.hasError == false) {
                this.$message.success("保存成功！");
                this.goBack();
              } else {

                this.$message.error(res.data.message);
              }
            });
          } else {
            this.$axios
                .put("/Meeting/" + this.meetingId + "", this.ruleForm)
                .then((res) => {
                  if (res.data.hasError == false) {
                    this.$message.success("编辑成功！");
                    this.goBack();
                  } else {

                    this.$message.error(res.data.message);
                  }
                });
          }
        } else {
          return false;
        }
      });
    },
    goBack() {
      this.editData = null;
      this.$emit("backFunStu");
      this.meetingId = "";
      this.editImg = "";
      this.$refs["ruleForm"].resetFields();
    },
    getUploadImg(imgSrc) {
      this.ruleForm.logo = imgSrc;
    },
  },
  components: {
    UploadImg,
  },
};
</script>
<style lang="scss" scope>
.img-box {
  float: right;
  width: 400px;
  position: absolute;
  top: 80px;
  right: 0px;
}

img {
  width: 100%;
}

#qrcode {
  position: absolute;
}
</style>